module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Tell us why you reject this campaign to work on more relevant pairing in the future.")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "width": "90%"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "body-1",
    attrs: {
      "label": "The campaign proposed was not relevant to me.",
      "color": "primary",
      "value": "The campaign proposed was not relevant to me.",
      "error": _vm.errors,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.campaign_proposed),
      callback: function($$v) {
        _vm.campaign_proposed = $$v
      },
      expression: "campaign_proposed"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "I can't accommodate the campaign timeline.",
      "color": "primary",
      "value": "I can't accommodate the campaign timeline.",
      "error": _vm.errors,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.campaign_timeline),
      callback: function($$v) {
        _vm.campaign_timeline = $$v
      },
      expression: "campaign_timeline"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Payout is an issue",
      "hint": "",
      "error": _vm.errors,
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.payout_issue),
      callback: function($$v) {
        _vm.payout_issue = $$v
      },
      expression: "payout_issue"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "error": _vm.errors,
      "label": "I am doing a competitor brand",
      "value": "I am doing a competitor brand",
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.competitor),
      callback: function($$v) {
        _vm.competitor = $$v
      },
      expression: "competitor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "error": _vm.errors,
      "label": "I do not associate with the brand.",
      "value": "I do not associate with the brand.",
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.not_associate),
      callback: function($$v) {
        _vm.not_associate = $$v
      },
      expression: "not_associate"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Others",
      "error": _vm.errors,
      "hint": "",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.others),
      callback: function($$v) {
        _vm.others = $$v
      },
      expression: "others"
    }
  })], 1)], 1), _vm._v(" "), (_vm.errors) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(this.errorMessage) + " ")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info",
      "width": "150"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-minus-circle")]), _vm._v(" Cancel ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "error",
      "width": "150"
    },
    on: {
      "click": function($event) {
        return _vm.reject()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Reject ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6c0de4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignInvite/RejectModal.vue
// module id = 2178
// module chunks = 0